import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
  static targets = [
    "tabBody",
    "tabNav",
  ];

  connect() {
    this.toggleTabs();
  }

  onNavClick(e) {
    e.preventDefault();
    this.toggleTabs(e.target.parentElement.dataset.tabIdValue);
  }

  toggleTabs(tabId = this.activeTabId) {
    this.tabNavTargets.forEach((el) => {
      el.classList.toggle("active", el.dataset.tabIdValue === tabId);
    });
    this.tabBodyTargets.forEach((el) => {
      el.classList.toggle("active", el.dataset.tabIdValue === tabId);
    });
  }

  get activeTabId() {
    return (
      this.tabNavTargets.find((el) => el.classList.contains("active")) ||
      this.tabNavTargets[0]
    ).dataset.tabIdValue
  }

  set activeTabId(tabId) {
    this.toggleTabs(tabId);
  }
}